import LanguageSkillTeacherForm from './LanguageSkillTeacherForm';

export default LanguageSkillTeacherForm;
